/* ==========================================================
   UNIVERSAL SWIPER INSTANCE CREATOR (Reusable)
   ========================================================== */
function createSwiperInstance(selector, options, uniqueKey) {
  const el = document.querySelector(selector);
  if (!el) return null;

  // Prevent duplicate initialization
  if (el.dataset.initialized === "true") return null;
  el.dataset.initialized = "true";

  return new Swiper(selector, options);
}

/* ==========================================================
   wishlist hide price
========================================================== */
function checkWishlistPremium() {
  document.querySelectorAll('.js-wishlist-item').forEach(function(item) {
    if (item.dataset.premiumChecked) return;
    item.dataset.premiumChecked = 'true';
    
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return;
    
    var handle = link.href.split('/products/')[1].split('?')[0];
    
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var priceEl = item.querySelector('.wl-sale');
        var comparePriceEl = item.querySelector('s');
        
        if (product.tags && product.tags.indexOf('premium-enquiry') !== -1) {
          // Premium product - show Connect for Pricing
          if (priceEl) priceEl.innerHTML = '<span style="color:#e44d26; font-weight:600;">Connect for Pricing</span>';
          if (comparePriceEl) comparePriceEl.style.display = 'none';
        } else {
          // Normal product - make price visible
          if (priceEl) priceEl.style.visibility = 'visible';
          if (comparePriceEl) comparePriceEl.style.visibility = 'visible';
        }
        // Always make price visible after check
        if (priceEl) priceEl.style.visibility = 'visible';
      });
  });
}

checkWishlistPremium();
var wishlistInterval = setInterval(function() {
  checkWishlistPremium();
}, 1000);
setTimeout(function() { clearInterval(wishlistInterval); }, 10000);
/* ==========================================================
   AMAZON SWIPER INIT — Uses data attributes
   ========================================================== */
function initAmazonSwiper(sectionId) {
  const selector = "#swiper-amazon-" + sectionId;

  const el = document.querySelector(selector);
  if (!el) return;

  const perView = Number(el.dataset.perviewDesktop);
  const spacing = Number(el.dataset.spaceBetween);

  return createSwiperInstance(selector, {
    slidesPerView: perView,
    spaceBetween: spacing,

    navigation: {
      nextEl: `.amazon-swiper${sectionId} .swiper-button-next`,
      prevEl: `.amazon-swiper${sectionId} .swiper-button-prev`
    },

    breakpoints: {
      0: { slidesPerView: 1.2, spaceBetween: 12 },
      750: { slidesPerView: perView, spaceBetween: spacing }
    }
  });
}

/* ==========================================================
   FEATURE HERO CAROUSEL INIT — Always 1 slide per view
   ========================================================== */
function initFeatureCarousel(sectionId) {
  const selector = "#feature-swiper-" + sectionId;

  const el = document.querySelector(selector);
  if (!el) return;

  return createSwiperInstance(selector, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    watchSlidesProgress: true,

    navigation: {
      nextEl: `.feature-carousel${sectionId} .swiper-button-next`,
      prevEl: `.feature-carousel${sectionId} .swiper-button-prev`
    },

    pagination: {
      el: `.feature-carousel${sectionId} .swiper-pagination`,
      clickable: true
    },

    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 12 },
      750: { slidesPerView: 1, spaceBetween: 20 }
    }
  });
}

/* ==========================================================
   AUTO INITIALIZATION ON PAGE LOAD
   ========================================================== */
document.addEventListener("DOMContentLoaded", () => {
  // Amazon
  document
    .querySelectorAll('[data-section-type="swipercustom"]')
    .forEach(el => initAmazonSwiper(el.dataset.sectionId));

  // Feature Hero Carousel
  document
    .querySelectorAll('[data-section-type="feature-carousel"]')
    .forEach(el => initFeatureCarousel(el.dataset.sectionId));
});

/* ==========================================================
   SHOPIFY EDITOR LIVE RELOAD
   ========================================================== */
document.addEventListener("shopify:section:load", (e) => {
  const sec = e.target;

  if (!sec.dataset.sectionId) return;

  // Detect by section type
  if (sec.dataset.sectionType === "swipercustom") {
    initAmazonSwiper(sec.dataset.sectionId);
  }

  if (sec.dataset.sectionType === "feature-carousel") {
    initFeatureCarousel(sec.dataset.sectionId);
  }
});
/* ============================================================
   HOVER-TO-SELECT VARIANT SWATCHES
   This replaces click behavior with hover behavior.
   Works for all product variant fieldsets automatically.
   ============================================================ */

/* ============================================================
   SAFE & ISOLATED — HOVER-TO-SELECT VARIANTS
   ------------------------------------------------------------
   ✔ Only affects variant swatches inside:
       fieldset.single-option-radio
   ✔ Does NOT affect any other elements on the entire website
   ✔ Runs ONLY on product pages (because fieldsets won't exist elsewhere)
   ✔ Works for all future variants automatically
   ✔ Does NOT modify styling or other scripts
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {

  // Select variant swatch groups ONLY inside product pages
  const variantFieldsets = document.querySelectorAll(
    "fieldset.single-option-radio"
  );

  // If no variant swatches exist → stop script (protects all other pages)
  if (!variantFieldsets.length) return;

  variantFieldsets.forEach((fieldset) => {
    const inputs = fieldset.querySelectorAll('input[type="radio"]');

    inputs.forEach((input) => {
      const label = fieldset.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );

      if (!label) return;

      // HOVER → safely select the corresponding variant
      label.addEventListener("mouseenter", () => {
        input.checked = true;

        // Trigger Shopify's variant update logic
        input.dispatchEvent(new Event("change", { bubbles: true }));
        input.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });
  });
});
/* ============================================================
   FLOATING CALL BUTTON VISIBILITY CONTROLLER
   - Hides button during active scroll
   - Detects scroll stop with debounce
   - Shows button after 10s delay
   - Prevents distraction while browsing
   ============================================================ */

 (function () {
    if (window.__callBtnInitialized) return; /* prevents duplicate execution */
    window.__callBtnInitialized = true;

    let scrollTimer;
    let delayTimer;
    const callBtn = document.querySelector('.floating-call-btn');

    if (!callBtn) return;

    /* Start hidden */
    callBtn.classList.add('call-hidden');

    window.addEventListener('scroll', function () {
      callBtn.classList.remove('call-visible');
      callBtn.classList.add('call-hidden');

      clearTimeout(scrollTimer);
      clearTimeout(delayTimer);

      /* Detect scroll stop */
      scrollTimer = setTimeout(function () {
        delayTimer = setTimeout(function () {
          callBtn.classList.remove('call-hidden');
          callBtn.classList.add('call-visible');
        }, 7000);
      }, 300);
    });

    /* Initial show after page load */
    setTimeout(function () {
      callBtn.classList.remove('call-hidden');
      callBtn.classList.add('call-visible');
    }, 12000);
  })();
